<template>
	<div class="events">
		<navComponent/>
		<eventDetails></eventDetails>
		<footerComp/>

<!--		<div class="container mt-4">-->
<!--			<h4><b>-->
<!--				<router-link to="/dashboard"><i class="fa fa-arrow-left" style="cursor: pointer;"></i></router-link>-->
<!--				Event's Information</b>-->
<!--			</h4>-->
<!--			<hr>-->
<!--			<div class="card">-->
<!--				<div class="card-body">-->
<!--					<h4>-->
<!--						<b>{{event.title}}</b>-->
<!--					</h4>-->
<!--					<small class="badge badge-secondary" style="font-size: 14px;">{{event.created_at |-->
<!--						moment("from", "now")}} created</small>-->
<!--					<div class="form-group mt-4">-->
<!--						<label>Copy & share this link to speaker and audience that you want to invite for this event.</label>-->
<!--						<input type="text " class="form-control" :value="event.link" disabled style="width: 100%;">-->
<!--					</div>-->
<!--					<div class="form-group mt-3">-->
<!--						<button class="btn btn-primary" v-if="event.status === 'CREATED'" @click="goLiveFunction()">Go Live</button>-->
<!--						<button class="btn btn-outline-danger" v-else-if="event.status === 'STARTED'"><i class="fa fa-circle"></i> Live-->
<!--						</button>-->
<!--						<button class="btn btn-secondary" v-else>FINISHED</button>-->
<!--						<router-link :to="'/meeting/' + event.event_id" class="btn btn-primary ml-2" v-if="event.status === 'STARTED'">See Event-->
<!--						</router-link>-->
<!--					</div>-->
<!--				</div>-->
<!--			</div>-->
<!--			<br>-->
<!--			<nav>-->
<!--				<div class="nav nav-tabs" id="nav-tab" role="tablist">-->
<!--					<a-->
<!--									class="nav-item nav-link active" id="nav-details-tab" data-toggle="tab" href="#nav-details" role="tab"-->
<!--									aria-controls="nav-details" aria-selected="true">Details</a>-->
<!--					<a-->
<!--									class="nav-item nav-link" id="nav-sessions-tab" data-toggle="tab" href="#nav-sessions" role="tab"-->
<!--									aria-controls="nav-sessions" aria-selected="false">Sessions</a>-->
<!--					<a-->
<!--									class="nav-item nav-link" id="nav-users-tab" data-toggle="tab" href="#nav-users" role="tab"-->
<!--									aria-controls="nav-users" aria-selected="false">Registered Users</a>-->
<!--				</div>-->
<!--			</nav>-->
<!--			<div class="tab-content" id="nav-tabContent">-->
<!--				<div class="tab-pane fade show active" id="nav-details" role="tabpanel" aria-labelledby="nav-details-tab">-->
<!--					<div class="row mt-4 mb-4">-->
<!--						<div class="col-12 col-md-4">-->
<!--							<img :src="event.image" alt="" style="width: 100%;">-->
<!--						</div>-->
<!--						<div class="col-12 col-md-8">-->
<!--							<h3><b>{{event.title}}</b></h3>-->
<!--							<p>-->
<!--								<label>Timings</label> <br>-->
<!--								Start at <b> {{event.start_date | moment("h:mm a, dddd, MMMM Do YYYY") }}</b>-->
<!--								<br>End at <b> {{event.end_date | moment("h:mm a, dddd, MMMM Do YYYY") }}</b>-->
<!--							</p>-->
<!--						</div>-->
<!--						<div class="col-12 mt-4">-->
<!--							<div class="alert" style="border: 1px solid red; border-radius: 5px">This event is a private event, please-->
<!--								copy the link and invite the participants.-->
<!--							</div>-->
<!--							<label>Short Description</label>-->
<!--							<p class="lead">{{event.short_desc}}</p>-->
<!--							<label>Long Description</label>-->
<!--							<p class="lead" v-html="event.long_desc"></p>-->
<!--						</div>-->
<!--						<hr>-->
<!--					</div>-->
<!--				</div>-->
<!--				<div class="tab-pane fade" id="nav-sessions" role="tabpanel" aria-labelledby="nav-sessions-tab">-->
<!--					<div class="mt-4 mb-4">-->
<!--						<button class="btn btn-secondary" disabled>Create New Session</button>-->
<!--					</div>-->
<!--					<div-->
<!--									class="row p-3"-->
<!--									style="border: 1px solid #1B1B1B; border-radius: 5px;"-->
<!--									v-for="(s, i) in event.sessions" :key="i">-->
<!--						<div class="col-12">-->
<!--							<h4>-->
<!--								<b>{{s.session_name}}</b>-->
<!--								<small class="float-right" style="font-size: 14px;">{{s.duration}}mins</small>-->
<!--							</h4>-->
<!--							<p class="mt-3 mb-1"><b>Speakers</b></p>-->
<!--							<div class="card mb-2" v-for="(u, index) in s.speakers" :key="index">-->
<!--								<div class="card-body row">-->
<!--									<div class="col-4 col-md-2 text-center" v-if="u.photoURL">-->
<!--										<img :src="u.photoURL" alt="" style="width: 60%;border-radius:50%;">-->
<!--									</div>-->
<!--									<div class="col-4 col-md-2 text-center" v-else>-->
<!--										<figure-->
<!--														:data-letters="u.name.charAt(0).toUpperCase()"-->
<!--														style="font-weight: bold;"></figure>-->
<!--									</div>-->
<!--									<div class="col-8 col-md-10">-->
<!--										<h4 class="mb-0"><b>{{u.name}}</b></h4>-->
<!--										<small>{{u.designation}} at {{u.company}}, {{u.location}}</small>-->
<!--										<p>{{u.bio}}</p>-->
<!--									</div>-->
<!--								</div>-->
<!--							</div>-->
<!--						</div>-->
<!--					</div>-->
<!--				</div>-->
<!--				<div class="tab-pane fade" id="nav-users" role="tabpanel" aria-labelledby="nav-users-tab">-->
<!--					<div class="mt-3 mb-4">-->
<!--						<table class="table table-dark" v-if="event.users.length > 0">-->
<!--							<thead>-->
<!--							<tr>-->
<!--								<th scope="col">#</th>-->
<!--								<th scope="col">Name</th>-->
<!--								<th scope="col">Email</th>-->
<!--								<th scope="col">Designation</th>-->
<!--								<th scope="col">Location</th>-->
<!--								<th scope="col">Registered Time</th>-->
<!--							</tr>-->
<!--							</thead>-->
<!--							<tbody>-->
<!--							<tr v-for="(r,ind) in event.users" :key="ind">-->
<!--								<th scope="row">{{ind + 1}}</th>-->
<!--								<td>{{r.name}}</td>-->
<!--								<td>{{r.email}}</td>-->
<!--								<td>{{r.designation}}</td>-->
<!--								<td>{{r.location}}</td>-->
<!--								<td>{{r.registered_at | moment("h:mm a, dddd, MMMM Do YYYY") }}</td>-->
<!--							</tr>-->
<!--							</tbody>-->
<!--						</table>-->
<!--						<div v-else class="text-center p-4">-->
<!--							<p><b>No registered user found</b></p>-->
<!--						</div>-->
<!--					</div>-->
<!--				</div>-->
<!--			</div>-->
<!--		</div>-->
	</div>
</template>

<script>
  import navComponent from '@/components/nav.vue'
  import eventDetails from '@/components/dashboard/event-details.vue'
  import footerComp from '@/components/footer.vue'
  export default {
    name: 'home',
    data() {
      return {
      }
    },
    created() {
    },
    components: {
      navComponent,
	    eventDetails,
      footerComp
    },
    methods: {
      // goLiveFunction: function () {
      //   let data = {
      //     "event_id": this.$route.params.id,
      //     "community_id": this.user.community.community_id,
      //   }
      //   this.$store.dispatch('goLive', data).then(resp => {
      //     if (resp.data.status === "success") {
      //       this.event = resp.data.data
      //       this.$toast.open({
      //         message: "Event is live now.",
      //         type: 'success',
      //         position: 'top'
      //       });
      //       this.getEventDetailFunction()
      //     } else {
      //       this.$toast.open({
      //         message: resp.data.data,
      //         type: 'error',
      //         position: 'top'
      //       });
      //     }
      //   })
      // }
    }
  }
</script>
